/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
import { ChevronRight } from 'lucide-react'
import { useTranslations } from 'next-intl'
import * as React from 'react'

import { useCarousel } from '@/components/e-commerce/kits/kit-gallery-carousel/Carousel'
import { cn } from '@/utils/css'

const CarouselNext = React.forwardRef<HTMLButtonElement, React.HTMLAttributes<HTMLButtonElement>>(
  ({ className, ...props }, ref) => {
    const t = useTranslations('CarouselNext')
    const { scrollNext, canScrollNext } = useCarousel()

    return (
      <button
        ref={ref}
        className={cn(
          'absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center pointer-events-auto',
          'bg-white/50 rounded-full ring-1 ring-gray-700',
          !canScrollNext && 'hidden',
          className,
        )}
        disabled={!canScrollNext}
        onClick={scrollNext}
        {...props}
      >
        <ChevronRight className={'w-6 h-6 text-gray-700'} />
        <span className={'sr-only'}>{t('nextImage')}</span>
      </button>
    )
  },
)
CarouselNext.displayName = 'CarouselNext'

export { CarouselNext }
